const isVisible = (el) => {
    return el.offsetWidth > 0 && el.offsetHeight > 0;
};

const isMobile = () => {
    return window.innerWidth < 1366;
}

/////////////////////////////////////////
////////// WHEN DOM READY ///////////////
/////////////////////////////////////////
let sliderPrix;
let sliderMensualites;
document.addEventListener("DOMContentLoaded", function () {
    let selectOptionModele = jQuery('#selectModele option');

    const redirectToSearch = Array.from(document.querySelectorAll('.js-redirect-to-search'));
    if (redirectToSearch.length) {
        redirectToSearch.forEach((redirect) => {
            redirect.addEventListener('click', (e) => {
                e.preventDefault();
                clearLocalStoragePourRecherche();
                window.location.href = redirect.href;
            })
        });
    }

    //PAGE TROUVER SON VEHICULE
    let marque = document.getElementById("mar");
    let modele = document.getElementById("mod");
    let categorie = document.getElementById("cat");
    let prix = document.getElementById("prix");
    let mensualite = document.getElementById("mens");
    let annee = document.getElementById("annee");
    let kilometrage = document.getElementById("km");
    let typeVente = document.getElementById("occ");
    let typeEnergie = document.getElementById("energie");
    let typeBoite = document.getElementById("boite");
    let concession = document.getElementById("conc");
    let utilitaire_particulier = document.getElementById("utilitaire_particulier");
    let accroche_predefinie = document.getElementById("accroche_predefinie");
    let search_query = document.getElementById("search_query");
    // let reference = document.getElementById("ref");

    //si filtre par url
    if (marque || categorie || prix || mensualite || annee || kilometrage || typeVente || typeEnergie || typeBoite || concession || utilitaire_particulier || accroche_predefinie || search_query/*||reference*/) {
        rechercheParUrl(marque, modele, categorie, prix, mensualite, annee, kilometrage, typeVente, typeEnergie, typeBoite, concession, utilitaire_particulier, accroche_predefinie, search_query/*, reference*/);
    }

    let formRecherche = document.getElementById("formRecherche");
    let redirectOnSubmit = false;
    if (typeof formRecherche !== "undefined" && formRecherche != null) {
        redirectOnSubmit = formRecherche.querySelector('input[name="redirect_on_submit"]') ? formRecherche.querySelector('input[name="redirect_on_submit"]').value : false;

        setSelectFromLocalStoragePourRechercheSimple();
        setSelectFromLocalStoragePourRechercheDetaillee();
        if (hasInitialSelectedValueHidden()) {
            jQuery(".more-criteres").addClass('d-block');
            jQuery(".plus-de-criteres").text('- Moins d\'options');
        }

        formRecherche.onsubmit = function (e) {
            e.preventDefault();
            searchSubmit();
        };

        // Hightlight select with value
        const $sldSearchSelects = formRecherche.querySelectorAll('select');
        
        if (Array.from($sldSearchSelects).length) {

            Array.from($sldSearchSelects).forEach(($select) => {
                $select.addEventListener('change', (evt) => {
                    setSelectHighlighted(evt.target);
                });

                setSelectHighlighted($select);
            });
        }
    }

    const searchFormMobileTriggerBtn = document.querySelector('#searchFormMobileTriggerBtn');
    if (searchFormMobileTriggerBtn) {
        searchFormMobileTriggerBtn.addEventListener('click', (event) => {
            event.preventDefault();
            Array.from(document.querySelectorAll(['.search-hero', '#searchFormWrapper'])).forEach((el) => el.classList.add('is-visible'));
        });

        if (window.location.hash && window.location.hash === '#search') {
            Array.from(document.querySelectorAll(['.search-hero', '#searchFormWrapper'])).forEach((el) => el.classList.add('is-visible'));
        }
    }
    const searchFormMobileTriggerCloseBtn = document.querySelector('#searchFormMobileTriggerCloseBtn');
    if (searchFormMobileTriggerCloseBtn) {
        searchFormMobileTriggerCloseBtn.addEventListener('click', (event) => {
            event.preventDefault();
            Array.from(document.querySelectorAll(['.search-hero', '#searchFormWrapper'])).forEach((el) => el.classList.remove('is-visible'));
        });
    }

    const searchFormPDFTriggerBtn = document.querySelector('#recherchePDF');
    if (searchFormPDFTriggerBtn) {
        searchFormPDFTriggerBtn.addEventListener('click', (event) => {
            document.querySelector('#formRecherche').submit();
        });
    }

    if (formRecherche) {
        // Slider prix
        sliderPrix = new Slider('#search-price', {});
        const $sliderPrixMinLabel = document.querySelector('#search-price-min');
        const $sliderPrixMaxLabel = document.querySelector('#search-price-max');

        // Slider prix - on init
        sliderPrix.handle1.dataset.valueLabel = sliderPrix.options.value[0] + ' €';
        sliderPrix.handle2.dataset.valueLabel = sliderPrix.options.value[1] + ' € et +';

        $sliderPrixMinLabel.innerHTML = sliderPrix.options.value[0] + ' €';
        $sliderPrixMaxLabel.innerHTML = sliderPrix.options.value[1] + ' € et +';

        // Slider prix - on change
        sliderPrix.on('change', function(updated) {
            if (sliderMensualites) {
                sliderMensualites.setValue([sliderMensualites.options.min, sliderMensualites.options.max], true, true);
            }

            sliderPrix.handle1.dataset.valueLabel = updated.newValue[0] + ' €';

            const isMax = updated.newValue[1] === sliderPrix.options.max;
            sliderPrix.handle2.dataset.valueLabel = updated.newValue[1] + ' €' + (isMax ? ' et +' : '');

            $sliderPrixMinLabel.innerHTML = updated.newValue[0] + ' €';
            $sliderPrixMaxLabel.innerHTML = updated.newValue[1] + ' €' + (isMax ? ' et +' : '');
            
            document.querySelector('#budget-indicator').innerHTML = getSelectPrix().length ? ('Prix: '+$sliderPrixMinLabel.innerText+' - '+$sliderPrixMaxLabel.innerText) : '';
        });

        // Slider mensualite
        sliderMensualites = new Slider('#search-mensualite', {});
        const $sliderMensualiteMinLabel = document.querySelector('#search-mensualite-min');
        const $sliderMensualiteMaxLabel = document.querySelector('#search-mensualite-max');

        // Slider mensualite - on init
        sliderMensualites.handle1.dataset.valueLabel = sliderMensualites.options.value[0] + ' €';
        sliderMensualites.handle2.dataset.valueLabel = sliderMensualites.options.value[1] + ' €';

        $sliderMensualiteMinLabel.innerHTML = sliderMensualites.options.value[0] + ' €';
        $sliderMensualiteMaxLabel.innerHTML = sliderMensualites.options.value[1] + ' €';

        if (document.querySelector('#mens') && document.querySelector('#mens').innerText !== '') {
            const initialMensualites = parseInt(document.querySelector('#mens').innerText);
            
            $sliderMensualiteMaxLabel.innerHTML = initialMensualites + ' €';
            document.querySelector('#budget-indicator').innerHTML = 'Mensualités: '+$sliderMensualiteMinLabel.innerText+' - '+$sliderMensualiteMaxLabel.innerText;
            sliderMensualites.setValue([sliderMensualites.options.min, initialMensualites], true, true);
        }

        // Slider mensualite - on change
        sliderMensualites.on('change', function(updated) {
            if (sliderPrix) {
                sliderPrix.setValue([sliderPrix.options.min, sliderPrix.options.max], true, true);
            }

            sliderMensualites.handle1.dataset.valueLabel = updated.newValue[0] + ' €';
            sliderMensualites.handle2.dataset.valueLabel = updated.newValue[1] + ' €';
            
            $sliderMensualiteMinLabel.innerHTML = updated.newValue[0] + ' €';
            $sliderMensualiteMaxLabel.innerHTML = updated.newValue[1] + ' €';

            document.querySelector('#budget-indicator').innerHTML = getSelectMensualite().length ? ('Mensualités: '+$sliderMensualiteMinLabel.innerText+' - '+$sliderMensualiteMaxLabel.innerText) : '';
        });

        if (!redirectOnSubmit) {
            getFiltres();
        }
    }

    //Boutons Reset
    let boutonReset = document.getElementById("boutonReset");
    if (boutonReset) {
        boutonReset.onclick = function (e) {
            e.preventDefault();
            clearSearch();
        };
    }
    let voirTousVehicules = document.getElementById("voirTousVehicules");
    if (voirTousVehicules) {
        voirTousVehicules.onclick = function (e) {
            e.preventDefault();
            clearSearch();
        };
    }

    // Ordre de tri des résultats
    let formTriRecherche = document.getElementById("formTriRecherche");
    if (formTriRecherche) {
        formTriRecherche.onchange = function (e) {
            getFiltres();
        };
    }

    const sortMobileDropdownItems = Array.from(document.querySelectorAll('.sortMobileDropdownItem'));
    if (sortMobileDropdownItems.length) {
        const $sortSelect = document.querySelector('#triCroissantDecroissant');
        const currentSort = $sortSelect.value;
        sortMobileDropdownItems.forEach((sortMobileDropdownItem) => {
            if (sortMobileDropdownItem.dataset.sort == currentSort) {
                sortMobileDropdownItem.classList.add('is-active');
            }

            sortMobileDropdownItem.addEventListener('click', (e) => {
                e.preventDefault();
                $sortSelect.value = e.target.dataset.sort;
                getFiltres();

                sortMobileDropdownItems.forEach((di) => di.classList.remove('is-active'));
                e.target.classList.add('is-active');
            });
        });
    }

    // Occasion / Neuf
    let savedNewOrUsed = null;
    if (window.localStorage.criteresRechercheDetaillee) {
        savedNewOrUsed = JSON.parse(window.localStorage.criteresRechercheDetaillee).occasion_neuf;
    }
    const $selectNewOrUsed = document.getElementById('selectOccasionNeuf');
    const $checkboxUsed = document.getElementById('checkbox-used');
    const $checkboxNew = document.getElementById('checkbox-new');
    if ($selectNewOrUsed && $checkboxUsed && $checkboxNew) {
        const checkboxesNewOrUsed = [$checkboxUsed, $checkboxNew];
        checkboxesNewOrUsed.forEach((checkbox) => {
            // Has previous saved values
            if (savedNewOrUsed) {
                const selectValue = $selectNewOrUsed.querySelector('option[data-value="'+checkbox.dataset.selectValue+'"]').value;
                checkbox.checked = savedNewOrUsed === selectValue;
            }
            setTimeout(() => {
                checkbox.addEventListener('change', () => {
                    let isCheckedUsed = $checkboxUsed.checked;
                    let isCheckedNew = $checkboxNew.checked;
                    // Select both if they are unselected (else no result..)
                    if (!isCheckedUsed && !isCheckedNew) {
                        $checkboxUsed.checked = isCheckedUsed = true;
                        $checkboxNew.checked = isCheckedNew = true;
                    }

                    // Trigger select change (hacky but easiest)
                    if (isCheckedUsed && isCheckedNew) {
                        $selectNewOrUsed.value = $selectNewOrUsed.querySelector('option:first-child').value;
                    } else if (isCheckedUsed && !isCheckedNew) {
                        $selectNewOrUsed.value = $selectNewOrUsed.querySelector('option[data-value="'+$checkboxUsed.dataset.selectValue+'"]').value;
                    } else if (!isCheckedUsed && isCheckedNew) {
                        $selectNewOrUsed.value = $selectNewOrUsed.querySelector('option[data-value="'+$checkboxNew.dataset.selectValue+'"]').value;
                    }
                    $selectNewOrUsed.dispatchEvent(new Event('change'));
                });
            }), 0;
        });
    }

    function searchSubmit () {
        setLocalStorageFromSelectPourRechercheSimple();
        setLocalStorageFromSelectPourRechercheDetaillee();

        if (redirectOnSubmit) {
            window.location.href = "/trouver-son-vehicule/#resultats";
        } else {
            getFiltres();
            // Hide mobile form
            Array.from(document.querySelectorAll(['.search-hero', '#searchFormWrapper'])).forEach((el) => el.classList.remove('is-visible'));

            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery("#resultats").offset().top - jQuery('.navbarv2').height() - 10
            }, 500);
        }
    }

    function clearSearch () {
        clearLocalStoragePourRecherche();
        
        // Checkboxes utilitaires / tourisme
        document.getElementById('checkbox-utilitaire').checked = true;
        document.getElementById('checkbox-tourisme').checked = true;

        // Checkboxes occasion / neuf
        document.getElementById('checkbox-used').checked = true;
        document.getElementById('checkbox-new').checked = true;

        if (sliderPrix) {
            sliderPrix.setValue([sliderPrix.options.min, sliderPrix.options.max], true, true);
        }
        if (sliderMensualites) {
            sliderMensualites.setValue([sliderMensualites.options.min, sliderMensualites.options.max], true, true);
        }

        setSelectFromLocalStoragePourRechercheSimple();
        setSelectFromLocalStoragePourRechercheDetaillee();

        Array.from(document.querySelectorAll('.sld-research')).forEach(($sldSearchForm) => {
            const $searchField = $sldSearchForm.querySelector('.js-sld-research-input');
            const $searchSuggestions = $sldSearchForm.querySelector('.js-sld-research-suggestions ul');

            $searchField.value = '';
            $searchSuggestions.innerHTML = '';
            $searchSuggestions.classList.remove('has-suggestions');
        });

        // Remove .highlighted
        Array.from(document.querySelectorAll('.form-control.highlighted')).forEach(($el) => $el.classList.remove('highlighted'));

        if (!redirectOnSubmit) {
            getFiltres();
        }
    }

    function setSelectHighlighted ($select) {
        if ($select.value !== '' && $select.value !== 'default') {
            $select.classList.add('highlighted');
        } else {
            $select.classList.remove('highlighted');
        }
    }

    let searchModels = [];
    
    if (window.sgmaProducts && window.sgmaProducts.searchAutocompleteJsonUrl) {
        fetch(window.sgmaProducts.searchAutocompleteJsonUrl, { cache: "no-store" })
            .then((response) => {
                if (response.status === 200) {
                    response.text().then((jsonData) => {
                        searchModels = JSON.parse(jsonData);
                    });
                }
            });
    }

    let sldRecherche = document.querySelectorAll('.sld-research');
    if (sldRecherche.length) {
        sldRecherche.forEach(($sldSearchForm) => {
            const $searchField = $sldSearchForm.querySelector('.js-sld-research-input');
            const $searchSuggestions = $sldSearchForm.querySelector('.js-sld-research-suggestions ul');

            const search = (str) => {
                let results = [];
                const val = str.toLowerCase();
            
                for (let i = 0; i < searchModels.length; i++) {
                    if (searchModels[i]['name'].toLowerCase().indexOf(val) > -1) {
                        results.push(searchModels[i]);
                    }
                }
            
                return results;
            }
            
            const searchHandler = (e) => {
                if (e.key !== 'Enter') {
                    const inputVal = e.currentTarget.value;
                    let results = [];
                    if (inputVal.length > 0) {
                        results = search(inputVal);
                    }
                    showSuggestions(results, inputVal);
                }
            }
            
            const showSuggestions = (results, inputVal) => {
                
                $searchSuggestions.innerHTML = '';
            
                if (results.length > 0) {
                    for (let i = 0; i < results.length; i++) {
                        let searchName = results[i].name;
                        const brandId = results[i].brand_term_id;
                        const brandSlug = results[i].brand_slug;
                        const modelId = results[i].model_term_id;
                        const modelSlug = results[i].model_slug;
                        const categorySlug = results[i].category_slug;
                        // Highlights only the first match
                        // TODO: highlight all matches
                        const match = searchName.match(new RegExp(inputVal, 'i'));
                        searchName = searchName.replace(match[0], `<strong>${match[0]}</strong>`);
                        if (categorySlug) {
                            $searchSuggestions.innerHTML += `<li data-category-slug="${categorySlug}">${searchName}</li>`;
                        } else {
                            $searchSuggestions.innerHTML += `<li data-brand-id="${brandId}" data-model-id="${modelId}" data-brand-slug="${brandSlug}" data-model-slug="${modelSlug}">${searchName}</li>`;
                        }
                    }
                    $searchSuggestions.querySelector('li:first-child').classList.add('suggested');
                    $searchSuggestions.classList.add('has-suggestions');
                } else {
                    results = [];
                    $searchSuggestions.innerHTML = '';
                    $searchSuggestions.classList.remove('has-suggestions');
                }
            }
            
            const useSuggestion = (e) => {
                $searchField.value = e.target.innerText;
                $searchField.focus();
                $searchSuggestions.innerHTML = '';
                $searchSuggestions.classList.remove('has-suggestions');
                
                // if (e.target.dataset.categorySlug) {
                //     redirectSearchWithCategory(e.target.dataset.categorySlug);
                // } else {
                //     redirectSearchWithBrandAndModel(e.target.dataset.brandId, e.target.dataset.modelId);
                // }
                searchRedirect({
                    category_slug: e.target.dataset.categorySlug,
                    brand_slug: e.target.dataset.brandSlug,
                    model_slug: e.target.dataset.modelSlug,
                    brand_term_id: e.target.dataset.brandId,
                    model_term_id: e.target.dataset.modelId,
                    name: e.target.innerText
                });
            }

            const searchRedirect = (suggestionSearchItem) => {
                let redirectUrl = `${document.location.origin}/trouver-son-vehicule/`;

                if (suggestionSearchItem.brand_term_id == -1 && suggestionSearchItem.model_term_id == -1) {
                    redirectUrl += `?search=${suggestionSearchItem.name}`;
                } else if (suggestionSearchItem.category_slug) {
                    redirectUrl += `${suggestionSearchItem.category_slug}/`;
                } else if (suggestionSearchItem.brand_slug) {
                    redirectUrl += `${suggestionSearchItem.brand_slug}/`;
                    if (suggestionSearchItem.model_slug) {
                        redirectUrl += `${suggestionSearchItem.model_slug}/`;
                    }
                }
                document.location.href = redirectUrl;
            }

            const redirectSearchWithBrandAndModel = (brandId, modelId) => {
                changeSelected("#selectMarque", brandId);
                document.getElementById("selectMarque").dispatchEvent(new Event('change'));
                setTimeout(() => {
                    if (modelId !== '') {
                        changeSelected("#selectModele", modelId);
                        document.getElementById("selectModele").dispatchEvent(new Event('change'));
                    }
                    searchSubmit();
                }, 0);
            }

            const redirectSearchWithCategory = (categorySlug) => {
                changeSelected("#selectCategorie", categorySlug);
                document.getElementById("selectCategorie").dispatchEvent(new Event('change'));
                setTimeout(() => {
                    searchSubmit()
                }, 0);
                
            }

            $sldSearchForm.addEventListener('submit', function (e) {
                e.preventDefault();
                const searchQuery = $searchField.value.trim();
                if (searchQuery != '') {
                    const suggestions = search(searchQuery);
                    if (suggestions.length) {
                        $searchField.value = suggestions[0].name;
                        $searchField.focus();
                        $searchSuggestions.innerHTML = '';
                        $searchSuggestions.classList.remove('has-suggestions');
                        
                        searchRedirect(suggestions[0]);
                        // if (suggestions[0].category_slug) {
                        //     redirectSearchWithCategory(suggestions[0].category_slug);
                        // } else {
                        //     redirectSearchWithBrandAndModel(suggestions[0].brand_term_id, suggestions[0].model_term_id);
                        // }
                    } else {
                        searchRedirect({
                            name: searchQuery,
                            brand_term_id: -1,
                            model_term_id: -1,
                            category_slug: null,
                        });
                    }
                }
            });

            $searchField.addEventListener('keyup', searchHandler);
            $searchSuggestions.addEventListener('click', useSuggestion);
        });
    }

    function changeSelected(select, value) {
        let sldSelect = jQuery(select);
        if (value != null && value !== "") {
            sldSelect.val(value);
            sldSelect.change();
        } else {
            sldSelect.val('');
        }
    }

    //////////////FIN TROUVER SON VEHICULE////////////////

    // Home page et Trouver son véhicule
    // Sélection d'un modèle
    let marqueSelect = document.getElementById("selectMarque");
    if (marqueSelect) {
        let criteres = JSON.parse(window.localStorage.getItem("criteresRecherche"));
        let selectOption = jQuery('#selectModele option').detach();
        if (selectOption) {
            if (document.getElementById("selectMarque").value.toString()) {
                let marque = document.getElementById("selectMarque").value.toString();
                jQuery('#selectModele').empty().append(selectOption.filter('.default')).append(selectOption.filter('.' + marque));
                setSelectModele(criteres.modele);
            } else {
                jQuery('#selectModele').empty().append(selectOption.filter('.default'));
                setSelectModele("");
            }

            marqueSelect.addEventListener("change", function (e) {
                let marque = document.getElementById("selectMarque").value.toString() ? document.getElementById("selectMarque").value.toString() : 'default';
                jQuery('#selectModele').empty().append(selectOption.filter('.default')).append(selectOption.filter('.' + marque));
                setSelectModele("");
            });
        }
    }

    ///////////////// FORM MODIFICATION ALERTE ///////////
    let marqueModifAlerteSelect = document.getElementById("selectMarqueModifAlerte");
    if (marqueModifAlerteSelect) {
        let selectOption = jQuery('#selectModeleModifAlerte option');
        if (selectOption) {
            let modeleInitial = jQuery('#selectModeleModifAlerte option:selected')[0].value.toString();
            selectOption.detach();

            let marque = document.getElementById("selectMarqueModifAlerte").value.toString() ? document.getElementById("selectMarqueModifAlerte").value.toString() : 'default';
            jQuery('#selectModeleModifAlerte').empty().append(selectOption.filter('.default')).append(selectOption.filter('.' + marque));
            jQuery('#selectModeleModifAlerte option').removeAttr("selected");
            jQuery('#selectModeleModifAlerte option[value="' + modeleInitial + '"]').attr('selected', 'selected');

            marqueModifAlerteSelect.addEventListener("change", function (e) {
                let marque = document.getElementById("selectMarqueModifAlerte").value.toString() ? document.getElementById("selectMarqueModifAlerte").value.toString() : 'default';
                jQuery('#selectModeleModifAlerte').empty().append(selectOption.filter('.default')).append(selectOption.filter('.' + marque));
                jQuery('#selectModeleModifAlerte option').removeAttr("selected");
                jQuery('#selectModeleModifAlerte option[value=""]').attr('selected', 'selected');
            });
        }
    }
    ///////////////// FIN FORM MODIFICATION ALERTE ///////////

    // Sur les pages Etablissements : CTA vers les établissements
    let rechercheEtablissement = document.getElementById(
        "etablissementRecherche"
    );
    if (rechercheEtablissement) {
        rechercheEtablissement.onclick = function (e) {
            e.preventDefault();
            clearLocalStoragePourRecherche();
            if (window.localStorage.getItem("criteresRechercheDetaillee")) {
                let criteresRechercheDetaillee = JSON.parse(
                    window.localStorage.getItem("criteresRechercheDetaillee")
                );
                criteresRechercheDetaillee.concession = jQuery(
                    "#etablissementRecherche"
                ).attr("data-etablissement");
                localStorage.setItem(
                    "criteresRechercheDetaillee",
                    JSON.stringify(criteresRechercheDetaillee)
                );
            }
            // setSelectFromLocalStoragePourRechercheSimple();
            // setSelectFromLocalStoragePourRechercheDetaillee();
            window.location.href = "/trouver-son-vehicule/#resultats";
        };
    }

    ////////////// CTA PAGE VEHICULES HYBRIDES ET ELECTRIQUES /////////
    let boutonCTAElectrique = document.getElementById("cta_electrique");
    if (boutonCTAElectrique) {
        boutonCTAElectrique.onclick = function (e) {
            e.preventDefault();
            rechercheVehiculeselectriques();
        };
    }

    function rechercheVehiculeselectriques() {
        clearLocalStoragePourRecherche();
        if (window.localStorage.getItem("criteresRechercheDetaillee")) {
            let criteresRechercheDetaillee = JSON.parse(
                window.localStorage.getItem("criteresRechercheDetaillee")
            );
            criteresRechercheDetaillee.type_energie = "electrique";
            localStorage.setItem(
                "criteresRechercheDetaillee",
                JSON.stringify(criteresRechercheDetaillee)
            );
        }
        window.location.href = "/trouver-son-vehicule/#resultats";
    }
    ////////////FIN VEHICULES HYBRIDES ET ELECTRIQUES

    // Ajout des événements sur les pictos de mentions légales
    picto_mentions();
    modal_favoris();

    // Retaillage de la fenêtre : on bascule éventuellement les infos des formulaires
    if (formRecherche) {
        let current_size = window.innerWidth;

        let memoCategorie = getSelectCategorie();
        let memoMarque = getSelectMarque();
        let memoModele = getSelectModele();
        let memoPrixMax = getSelectPrixMax();
        let memoPrix = getSelectPrix();
        let memoMensualite = getSelectMensualite();

        let memoMensualiteMax = getSelectMensualiteMax();
        let memoKmMax = getSelectKmMax();
        let memoType_energie = getSelectEnergie();
        let memoType_boite = getSelectTypeBoite();
        let memoAnneeMin = getSelectAnneeMin();
        let memoOccasion_neuf = getSelectOccasionNeuf();
        let memoType_clientele = getSelectTypeClientele();
        let memoConcession = getSelectConcession();
        // let memoPret_a_partir = getPretAPartir();
        // let memoReference = getReference();

        window.onresize = function (e) {
            if (
                (current_size < 1279 && window.innerWidth >= 1279) ||
                (current_size >= 1279 && window.innerWidth < 1279)
            ) {
                // On passe de petit à grand
                // Ou de grand à petit
                setSelectCategorie(memoCategorie);
                setSelectMarque(memoMarque);
                setSelectModele(memoModele);
                setSelectPrixMax(memoPrixMax);
                setSelectPrix(memoPrix);
                setSelectMensualite(memoMensualite);

                setSelectMensualiteMax(memoMensualiteMax);
                setSelectKmMax(memoKmMax);
                setSelectEnergie(memoType_energie);
                setSelectTypeBoite(memoType_boite);
                setSelectAnneeMin(memoAnneeMin);
                setSelectOccasionNeuf(memoOccasion_neuf);
                setSelectTypeClientele(memoType_clientele);
                setSelectConcession(memoConcession);
                // setPretAPartir(memoPret_a_partir);
                // setReference(memoReference);
                current_size = window.innerWidth;
            }
        };
    }

    ///////////////////////////////////////////////////
    /////////////////  FIN DOM READY //////////////////
    ///////////////////////////////////////////////////
});

///////////////////////////////////////////////////
///////////FILTRES DE RECHERCHE ///////////////////
///////////////////////////////////////////////////
function search_start() {
    //console.log("Search: start");
    isLoading = true;
}

function search_end() {
    //console.log("Search: end");
    isLoading = false;
}

function render_error_search_vehicules(error) {
    let html = "";
    html += "Error de connexion au serveur (" + error + ")";
    html += "Merci de réessayer ultérieurement";

    jQuery("#results").html(html);
}

//RENDU DES RESULTATS DE RECHERCHE
function render_results_search_vehicules(data, nombreResultats, $append) {
    let html = ""; // Start loop
    let htmlHeader = '';
    const isRootPage = window.location.pathname === '/trouver-son-vehicule/';
    let resultSearchDescription = nombreResultats + ' ' + (nombreResultats === 1 ? 'véhicule correspondant est' : 'véhicules correspondants sont') + ' actuellement en vente chez Morbihan Auto';
    if (!$append) {
        let resultSearchQuery = ' ';
        if(window.sldGMA) {
            // Add Brand if set
            if (getSelectMarque()) {
                const resultSearchBrand = getSelectMarque() ? window.sldGMA.brands.find((brand) => brand.term_id+'' === getSelectMarque()) : null;
                resultSearchQuery += resultSearchBrand ? resultSearchBrand.value + ' ' : '';
            }

            // Add Model if set
            const resultSearchModel = getSelectModele() ? window.sldGMA.models.find((model) => model.term_id+'' === getSelectModele()) : null;
            resultSearchQuery += resultSearchModel ? resultSearchModel.value + ' ' : '';

            if (getSelectConcession()) {
                const resultSearchConcession = window.sldGMA.concessions.find((concession) => concession.ID+'' === getSelectConcession());
                if (resultSearchConcession.etablissement_ville) {
                    resultSearchDescription = nombreResultats + ' ' + (nombreResultats === 1 ? 'véhicule correspondant est' : 'véhicules correspondants sont') + ` actuellement en vente chez ${resultSearchConcession.post_title} à ${resultSearchConcession.etablissement_ville}`;
                }
            }
        }


        if (isRootPage) { 
            htmlHeader += `<div class="d-block d-lg-flex mb-0 h1">${resultSearchQuery !== ' ' ? resultSearchQuery + ':&nbsp;' : ''}<h1 class="d-inline mb-0 h1" data-title="${jQuery("#vehicules-search-header  h1").data('title')}">${jQuery("#vehicules-search-header h1").data('title')}</h1></div>`; 
        } else { 
            htmlHeader += `<h1 class="mb-0 h1" data-title="${jQuery("#vehicules-search-header h1").data('title')}">${jQuery("#vehicules-search-header h1").data('title')}</h1>`; 
        } 
    }

    if (data !== null && Object.keys(data).length > 0) {
        jQuery('#formTriRecherche').removeClass('d-none');

        if (!$append) {
            htmlHeader += `<h2 class="vehicules-search-header__subtitle font-weight-normal">${resultSearchDescription}</h2>`;

            // Update spin text result count
            const jsSearchResultCountText = Array.from(document.querySelectorAll('.js-search-result-count-text'));
            if (jsSearchResultCountText.length) {
                jsSearchResultCountText.forEach(($countElement) => {
                    $countElement.innerText = nombreResultats > 1 ? nombreResultats : '';
                });
            }
        }

        const renderMarketingSearchBanner = () => {
            if (!window.search_banner_slides || !Array.isArray(window.search_banner_slides) ||  !window.search_banner_slides.length) return '';

            let html = `<div class="card-cell card-cell--promo col-md-6 col-xl-4 ${window.search_banner_slides.length > 1 ? 'card-cell--flickity' : ''}">`;
            search_banner_slides.forEach(slide => {
                html += '<div class="card-container">';
                html += '    <div class="card border-0">';
                html += '      <a href="'+slide.url+'" class="card-body p-0">';
                html += '        <img class="d-block d-lg-none" src="'+slide.image_mobile+'" />';
                html += '        <img class="d-none d-lg-block" src="'+slide.image_desktop+'" />';
                html += '      </a>';
                html += '    </div>';
                html += '</div>';
            });
            html += '  </div>';
            return html;
        }

        let frequenceInterstitiel = parseInt(interstitiel.frequence) - 1 + '';
        for (let key in data) {
            let post = data[key];
            let titre_marque_modele = post.title.rendered;

            // Marketing ADS Banner
            if (key === '2' && !$append) {
                html += renderMarketingSearchBanner();
            } 

            if (key == frequenceInterstitiel) {
                html += '<div class="card-cell card-cell--interstitiel col-md-6 col-xl-4">';
                html += '<div class="card bg-dark border-0">';
                html += '<div class="card-body">';
                html += '<span class="after"></span>';
                html += '<div class="card-title h3">Vous souhaitez louer votre véhicule sur une longue durée ?</div>';
                html += '<div class="">Simulez votre mensualité en complétant vos informations sur une annonce véhicule.</div>';
                html += "</div>";
                html += "</div>";
                html += "</div>";
            }

            html += '<div class="card-cell col-md-6 col-xl-4">';
            html += '<div class="card">';
            const hasPlaceholderPhoto = post.petite_annonce_photos_count && post.petite_annonce_photos_count === 1 && post.stockage > 0;
            if (hasPlaceholderPhoto) {
                post.petite_annonce_photos = '/wp-content/themes/heureuses/img/product/no-photo-placeholder.jpg';
            }
            if (post.petite_annonce_photos) {
                html += '<a href="' + post.link + '" title="' + titre_marque_modele + '"><img class="card-img-top" src="' + post.petite_annonce_photos + '" alt="' + titre_marque_modele + '"></a>';
            } else {
                html += '<a href="' + post.link + '" title="' + titre_marque_modele + '"><div class="card-img-top"></div></a>';
            }

            html += '<div class="badges">';
                if (post.stockage > 0) {
                    if (isDisplayAccroche(post.petite_annonce_date_heure_fin_accroche)) {
                        html += getFormattedAccroche(post);
                    }
                } else {
                    html += '<span class="badge-accroche reserve">Vendu</span>';
                }
                if (post.petite_annonce_prix_en_baisse) {
                    html += '<span class="badge-accroche badge-accroche--color-primary">Baisse de prix</span>';
                } else if (post.petite_annonce_prix_en_baisse_constructeur && post.petite_annonce_kilometrage < 7000) {
                    html += '<span class="badge-accroche badge-accroche--color-primary">Baisse de prix constructeur</span>';
                } else if (post.petite_annonce_prix_en_baisse_constructeur) {
                    html += '<span class="badge-accroche badge-accroche--color-primary">Baisse de prix</span>';
                }
            html += '</div>';

            html += '<div class="card-body car-card-body">';

            // FAVORI
            let login = document.getElementsByClassName("logged-in");
            if (login.length) {
                html += ' <div class="favori favori-rounded">';
                if (Favorites.userFavorites != null) {
                    let favoritesPosts = Favorites.userFavorites[0].posts[post.id];
                    if (favoritesPosts) {
                        html += '<button class="simplefavorite-button" data-postid="' + post.id + '" data-siteid="1" data-groupid="1" data-favoritecount="1" style="">';
                        html += '<object data="/wp-content/themes/heureuses/img/favori-oui.svg" type="image/svg+xml" width="16" height="16"></object>';
                        html += "</button>";
                    }
                } else {
                    html += '<button class="simplefavorite-button" data-postid="' + post.id + '" data-siteid="1" data-groupid="1" data-favoritecount="1" style="">';
                    html += '<object data="/wp-content/themes/heureuses/img/favori-non.svg" type="image/svg+xml" width="16" height="16"></object>';
                    html += "</button>";
                }
                html += "</div>";
                // }
            } else {
                html += ' <div class="favori favori-rounded">';
                html += '<button class="not_logged_favori" data-postid="' + post.id + '" data-siteid="1" data-groupid="1" data-favoritecount="0" style="">';
                html += '<object data="/wp-content/themes/heureuses/img/favori-non.svg" type="image/svg+xml" width="16" height="16"></object>';
                html += "</button>";
                html += "</div>";
            }

            // REF / TITRE / PRIX
            if (post.petite_annonce_reference) {
                html += '<small>Ref: '+ post.petite_annonce_reference +'</small>';
            }
            html += '<div class="card-title">';
            html += '<span class="car-titre">';
            html += '<h3 class="m-0"><a href="' + post.link + '" title="' + titre_marque_modele + '">' + titre_marque_modele + '</a></h3>';
            if (post.petite_annonce_finition !== '') {
                html += '<div class="car-finition"><a href="' + post.link + '" title="' + titre_marque_modele + '">';
                html += '<span>' + post.petite_annonce_finition + '</span>';
                // post.petite_annonce_motorisation ? html += ' <span>' + post.petite_annonce_motorisation + '</span>' : "";
                html += "</a></div>";
            }

            html += "</span>";
            html += '<span class="wc-price">';
            
            const post_prix_en_baisse = post.petite_annonce_prix_en_baisse;
            const post_prix_en_baisse_value = post.petite_annonce_prix_en_baisse_value;
            const post_prix_en_baisse_constructeur = post.petite_annonce_prix_en_baisse_constructeur;
            const post_prix_en_baisse_constructeur_value = post.petite_annonce_prix_en_baisse_constructeur_value;

            if (post_prix_en_baisse) {
                html +=
                    "<span>" +
                    "<small class='wc-price__old-price'>" + formatNombre(post_prix_en_baisse_value) + " €</small>" +
                    formatNombre(post.petite_annonce_prix_affiche_ttc) +
                    " €<small class='wc-price__tax'>&nbsp;TTC</small></span>";
            } else if (post_prix_en_baisse_constructeur) {
                html +=
                    "<span>" +
                    "<small class='wc-price__old-price'>" + formatNombre(post_prix_en_baisse_constructeur_value) + " €</small>" +
                    formatNombre(post.petite_annonce_prix_affiche_ttc) +
                    " €<small class='wc-price__tax'>&nbsp;TTC</small></span>";
            } else {
                if (!post.petite_annonce_prix_affiche_ttc.length) {
                    html +=
                        "<span> N.C </span>";
                } else {
                    html +=
                        "<span>" +
                        formatNombre(post.petite_annonce_prix_affiche_ttc) +
                        " €<small class='wc-price__tax'>&nbsp;TTC</small></span>";
                }
            }
            if (post.petite_annonce_mensualite_typique > 0) {
                html +=
                    '<span><div class="infos-mensualite">A partir de <strong>' +
                    Math.ceil(post.petite_annonce_mensualite_typique) +
                    " €/mois</strong> ";
                html +=
                    '<button class="picto-info-mensualite" data-toggle="modal" data-target="#myModal" id="' +
                    post.petite_annonce_id_unique +
                    '">';
                html +=
                    '<svg enable-background="new 0 0 524.235 524.235" height="12" viewBox="0 0 524.235 524.235" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m262.118 0c-144.53 0-262.118 117.588-262.118 262.118s117.588 262.118 262.118 262.118 262.118-117.588 262.118-262.118-117.589-262.118-262.118-262.118zm17.05 417.639c-12.453 2.076-37.232 7.261-49.815 8.303-10.651.882-20.702-5.215-26.829-13.967-6.143-8.751-7.615-19.95-3.968-29.997l49.547-136.242h-51.515c-.044-28.389 21.25-49.263 48.485-57.274 12.997-3.824 37.212-9.057 49.809-8.255 7.547.48 20.702 5.215 26.829 13.967 6.143 8.751 7.615 19.95 3.968 29.997l-49.547 136.242h51.499c.01 28.356-20.49 52.564-48.463 57.226zm15.714-253.815c-18.096 0-32.765-14.671-32.765-32.765 0-18.096 14.669-32.765 32.765-32.765s32.765 14.669 32.765 32.765c0 18.095-14.668 32.765-32.765 32.765z"/></svg>';
                html += "</button>";
                html += "</div></span>";
            } else {
                html += '<span><div class="infos-mensualite"></div>';
                html += "</span>";
            }
            html += "</span>";
            html += "</div>";

            //     <!-- OPTIONS -->
            html += ' <div class="car-options">';
            html += post.petite_annonce_annee_modele
                ? '<span class="badge">' + post.petite_annonce_annee_modele + "</span>"
                : "";
            html += post.petite_annonce_kilometrage
                ? '<span class="badge kilometrage">' +
                formatNombre(post.petite_annonce_kilometrage) +
                " km</span>"
                : "";
            html +=
                post.petite_annonce_type_energie &&
                post.petite_annonce_type_energie !== "--"
                    ? '<span class="badge">' +
                    post.petite_annonce_type_energie +
                    "</span>"
                    : "";
            html +=
                post.petite_annonce_type_boite &&
                post.petite_annonce_type_boite !== "--"
                    ? post.petite_annonce_type_boite === "boite_manuelle"
                        ? '<span class="badge">Manuelle</span>'
                        : '<span class="badge">Automatique</span>'
                    : "";
            html += "</div>";

            html += '<div class="card-body__footer">';
                // Localisation
                html += '<div class="car-localisation">';
                html += '<svg viewBox="0 0 17.299 22.611" width="16" height="20" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<g transform="translate(-312.81 -1364.8)">\n' +
                    '<circle transform="translate(319.68 1367.7)" cx="2.211" cy="2.211" r="2.211" fill="#fff" data-name="Ellipse 17"/>\n' +
                    '<path transform="translate(319.68 1367.7)" d="M2.211,1.1A1.111,1.111,0,1,0,3.322,2.211,1.112,1.112,0,0,0,2.211,1.1m0-1.1A2.211,2.211,0,1,1,0,2.211,2.211,2.211,0,0,1,2.211,0Z" fill="currentColor" data-name="Ellipse 17 - Contour"/>\n' +
                    '<path transform="translate(-1974.5)" d="m2296.3 1379.3-0.435-0.6a51.827 51.827 0 0 1-4.114-6.51 5.568 5.568 0 0 1-0.286-3.876 4.755 4.755 0 0 1 4.836-3.442h0.1a4.711 4.711 0 0 1 4.923 4.134 6.455 6.455 0 0 1-0.761 4.008 57.88 57.88 0 0 1-3.82 5.695zm0.1-13.323h-0.087a3.685 3.685 0 0 0-3.786 2.612v6e-3a4.465 4.465 0 0 0 0.225 3.15 44.935 44.935 0 0 0 3.563 5.7 53 53 0 0 0 3.287-4.963 5.4 5.4 0 0 0 0.644-3.262v-5e-3a3.622 3.622 0 0 0-3.842-3.238z" fill="currentColor" data-name="Tracé 153"/>\n' +
                    '<path transform="translate(-1974 -.863)" d="M2287.8,1388.106a.954.954,0,0,1-.482-.126,1.086,1.086,0,0,1-.506-.893v-.02c.012-4.922.022-12.378,0-12.748a1.155,1.155,0,0,1,.993-1.172l2.1-.8a.55.55,0,1,1,.39,1.029l-2.213.839-.047.005a.428.428,0,0,0-.126.049c.028.737,0,11.091,0,12.7a1.238,1.238,0,0,0,.136-.064c.775-.419,3.342-1.51,4.275-1.9v-5.766a.55.55,0,0,1,1.1,0v6.5l-.338.141c-.036.015-3.628,1.52-4.514,2A1.647,1.647,0,0,1,2287.8,1388.106Z" fill="currentColor" data-name="Tracé 154"/>\n' +
                    '<path transform="translate(-1974.7 -1.585)" d="m2299.3 1389-5.891-2.519a0.55 0.55 0 0 1 0.433-1.011l4.358 1.864v-8.272a0.55 0.55 0 0 1 1.1 0z" fill="currentColor" data-name="Tracé 155"/>\n' +
                    '<path transform="translate(-1975.4 -.723)" d="M2299.606,1388.14a.55.55,0,0,1-.221-1.054l4.9-2.148.023,0c.074-.037.117-.159.117-.332v-12.344c-.744.273-1.264.441-1.286.448a.55.55,0,1,1-.338-1.047c.006,0,.556-.18,1.314-.46a1.037,1.037,0,0,1,1.073.095,1.057,1.057,0,0,1,.337.919v12.388a1.352,1.352,0,0,1-.936,1.4l-4.759,2.088A.549.549,0,0,1,2299.606,1388.14Z" fill="currentColor" data-name="Tracé 156"/>\n' +
                    '</g>\n' +
                    '</svg>\n';
                html += '<span>'+(post.petite_annonce_concession ? post.petite_annonce_concession.post_title : '')+'</span>';
                html += '</div>';
                // Link discover
                html += '<a href="'+ post.link +'" class="btn btn-outline-primary btn-sm">Découvrir</a>';
            html += '</div>';

            html += "</div>";
            html += "</div>";
            html += "</div>";
        } // Fin : for

        if (data.length < 3 && !$append) {
            if (data.length < 2) {
                html += '<div class="col-md-6 col-xl-4"></div>';
            }
            html += renderMarketingSearchBanner();
        }

        // }
    } else {
        jQuery("#vehicules-search-header").html("");
        jQuery("#vehicules-search-isotope").html("");
        jQuery('#formTriRecherche').addClass('d-none');

        htmlHeader += `<h2 class="vehicules-search-header__subtitle font-weight-normal">Aucun véhicule correspondant n'est actuellement en vente chez Morbihan Auto</h2>`;
        htmlHeader += `<div class="alert alert-primary" role="alert">Aucun résultat correspondant à votre recherche.</div>`;

        html += '<div class="col-12">';
        html +=
            '<div class="bg-dark p-5 d-flex flex-column flex-md-row justify-content-between">';
        html +=
            '<span class="col-md-6"><b>Pensez à créer une alerte ou faites une demande de recherche personnalisée, nos conseillers vous rappellent lorsque le véhicule recherché est disponible en avant-première.</b> </span>';
        html +=
            '<span class="mt-4 mt-md-0 col-md-6 d-inline-flex align-items-center"><a class="btn btn-primary ml-md-auto" href="/recherche-personnalisee" title="Créer une recherche">Créer une recherche</a></span>';
        html += "</div>";
        html += '<div class="row">';
    }

    if ($append) {
        jQuery('#vehicules-search-header').append(htmlHeader);
        jQuery("#vehicules-search-isotope").append(html);
    } else {
        jQuery('#vehicules-search-header').html(htmlHeader);
        jQuery("#vehicules-search-isotope").html(html);
    }

    initPromoSlidesFlickity();
}

//FILTRES DE RECHERCHE VIA META QUERY
let currentPage = 1;
let filtre = {};
let meta_id = 0;

function getFiltres() {
    currentPage = 1;
    filtre = {};
    meta_id = 0;

    //DECLARATION VARIABLES

    let criteres = JSON.parse(window.localStorage.getItem("criteresRecherche"));
    let criteresRD = JSON.parse(window.localStorage.getItem("criteresRechercheDetaillee"));

    ////////////// FILTRES ////////////////////////
    if (criteres.categorie !== "") {
        filtre["filter[product_cat]"] = criteres.categorie;
    }

    // Exclude sold products
    filtre["filter[meta_query][" + meta_id + "][key]"] = "_stock";
    filtre["filter[meta_query][" + meta_id + "][type]"] = "numeric";
    filtre["filter[meta_query][" + meta_id + "][value]"] = 0;
    filtre["filter[meta_query][" + meta_id + "][compare]"] = ">";
    meta_id++;

    if (criteres.marque !== "default") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_marque";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteres.marque;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
        meta_id++;
    }
    if (criteres.modele !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_modele";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteres.modele;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
        meta_id++;
    }
    if (criteres.prixMax !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_prix_affiche_ttc";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteres.prixMax;
        filtre["filter[meta_query][" + meta_id + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "<=";
        meta_id++;
    }
    if (criteres.prix && criteres.prix.length) {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_prix_affiche_ttc";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteres.prix;
        filtre["filter[meta_query][" + meta_id + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "BETWEEN";
        meta_id++;
    }
    if (criteresRD.mensualiteMax !== "") {
        let mens_id = 0;
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][key]"] = "petite_annonce_mensualite_typique";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][value]"] = criteresRD.mensualiteMax;
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][compare]"] = "<=";
        mens_id++;
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][key]"] = "petite_annonce_mensualite_typique";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][value]"] = "0";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + mens_id + "][compare]"] = ">";
        if (mens_id >= 1) {
            filtre["filter[meta_query][" + meta_id + "][meta_query][relation]"] = "AND";
        }
        meta_id++;
    }
    if (criteres.mensualite && criteres.mensualite.length) {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_mensualite_typique";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteres.mensualite;
        filtre["filter[meta_query][" + meta_id + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "BETWEEN";
        meta_id++;
    }
    if (criteresRD.kmMax !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_kilometrage";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.kmMax;
        filtre["filter[meta_query][" + meta_id + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "<=";
        meta_id++;
    }
    if (criteresRD.type_energie !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_type_energie";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.type_energie;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "IN";
        meta_id++;
    }
    if (criteresRD.type_boite !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_type_boite";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.type_boite;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
        meta_id++;
    }
    if (criteresRD.anneeMin !== "") {
        let nb_query_annee = 0;
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][key]"] = "petite_annonce_annee_modele";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][value]"] = criteresRD.anneeMin;
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][type]"] = "numeric";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][compare]"] = ">=";
        // TODO SLR: à quoi sert le code ci-dessous ?
        nb_query_annee++;
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][key]"] = "petite_annonce_annee_modele";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][value]"] = " ";
        filtre["filter[meta_query][" + meta_id + "][meta_query][" + nb_query_annee + "][compare]"] = "=";
        if (nb_query_annee >= 1) {
            filtre["filter[meta_query][" + meta_id + "][meta_query][relation]"] = "OR";
        }
        meta_id++;
    }
    if (criteresRD.occasion_neuf !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_type_vente";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.occasion_neuf;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "IN";
        meta_id++;
    }
    if (criteresRD.type_clientele !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_type_clientele";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.type_clientele;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
        meta_id++;
    }
    if (criteresRD.concession !== "") {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_concession";
        filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.concession;
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
        meta_id++;
    }

    if (criteresRD.pret_a_partir) {
        filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_accroches_predefinies";
        filtre["filter[meta_query][" + meta_id + "][value]"] = "pret_a_partir";
        filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
        meta_id++;
    }
    if (criteresRD.accrochePredefinie !== "") {
        if (criteresRD.accrochePredefinie == 'baisse_prix') {
            filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_prix_en_baisse";
            filtre["filter[meta_query][" + meta_id + "][value]"] = 1;
            filtre["filter[meta_query][" + meta_id + "][compare]"] = "=";
        } else {
            filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_accroches_predefinies";
            filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.accrochePredefinie;
            filtre["filter[meta_query][" + meta_id + "][compare]"] = "=";
        }
        meta_id++;
    }

    // if (criteresRD.premium === "premium") {
    //   filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_accroches_predefinies";
    //   filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.premium;
    //   filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
    //   filtre["filter[orderby]"] = "meta_value_num";
    //   filtre["filter[order]"] = "DESC";
    //   meta_id++;
    // }


    // if (criteresRD.reference !== "") {
    //   filtre["filter[meta_query][" + meta_id + "][key]"] = "petite_annonce_reference";
    //   filtre["filter[meta_query][" + meta_id + "][value]"] = criteresRD.reference;
    //   filtre["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
    //   filtre["filter[order]"] = "DESC";
    //   meta_id++;
    // }

    ////////////// FIN FILTRES ////////////////////////

    if (meta_id > 1) {
        filtre["filter[meta_query][relation]"] = "AND";
    }

    let tax_id = 0;

    // if (criteres.utilitaire_particulier && criteres.utilitaire_particulier === 'utilitaire') {
    //     filtre["filter[tax_query][relation]"] = "AND";
    //     filtre["filter[tax_query][" + tax_id + "][taxonomy]"] = "product_cat";
    //     filtre["filter[tax_query][" + tax_id + "][terms]"] = ['professionnel'];
    //     filtre["filter[tax_query][" + tax_id + "][field]"] = "slug";
    //     filtre["filter[tax_query][" + tax_id + "][operator]"] = "IN";
    //     tax_id++;
    // }

    filtre["filter[tax_query][relation]"] = "AND";
    filtre["filter[tax_query][" + tax_id + "][taxonomy]"] = "product_visibility";
    filtre["filter[tax_query][" + tax_id + "][terms]"] = ["exclude-from-search"];
    filtre["filter[tax_query][" + tax_id + "][field]"] = "name";
    filtre["filter[tax_query][" + tax_id + "][operator]"] = "NOT IN";
    tax_id++;
    filtre["filter[tax_query][" + tax_id + "][taxonomy]"] = "product_tag";
    filtre["filter[tax_query][" + tax_id + "][terms]"] = ["pa"];
    filtre["filter[tax_query][" + tax_id + "][field]"] = "slug";

    filtre["filter[posts_per_page]"] = 10;
    filtre["filter[paged]"] = 1;

//Ordre
    if (criteresRD.mensualiteMax !== "") {
        filtre["filter[meta_key]"] = "petite_annonce_mensualite_typique";
        filtre["filter[meta_value]"] = "-1";
        filtre["filter[meta_compare]"] = "!=";
        filtre["filter[orderby]"] = "meta_value_num";
        filtre["filter[order]"] = "DESC";
    } else if (criteres.prixMax !== "") {
        filtre["filter[meta_key]"] = "petite_annonce_prix_affiche_ttc";
        filtre["filter[orderby]"] = "meta_value_num";
        filtre["filter[order]"] = "DESC";
    } else if (criteresRD.kmMax !== "") {
        filtre["filter[meta_key]"] = "petite_annonce_kilometrage";
        filtre["filter[orderby]"] = "meta_value_num";
        filtre["filter[order]"] = "DESC";
    } else if (criteresRD.anneeMin !== "") {
        filtre["filter[meta_key]"] = "petite_annonce_annee_modele";
        filtre["filter[orderby]"] = "meta_value_num";
        filtre["filter[order]"] = "ASC";
    } else {
        filtre["filter[order]"] = "DESC";
    }


    ///////// TRIS CROISSANT/DECROISSANT ////////////
    const trisCroissantDecroissant = document.querySelector('#triCroissantDecroissant');

    if (trisCroissantDecroissant) {
        switch(trisCroissantDecroissant.value) {
            case 'prixCroissant':
                filtre["filter[meta_key]"] = "petite_annonce_prix_affiche_ttc";
                filtre["filter[orderby]"] = "meta_value_num";
                filtre["filter[order]"] = "ASC";
                break;
            case 'prixDecroissant':
                filtre["filter[meta_key]"] = "petite_annonce_prix_affiche_ttc";
                filtre["filter[orderby]"] = "meta_value_num";
                filtre["filter[order]"] = "DESC";
                break;
            case 'mensualiteCroissante':
                if (criteresRD.mensualiteMax === "") {
                    filtre["filter[meta_key]"] = "petite_annonce_mensualite_typique";
                    filtre["filter[meta_value]"] = "-1";
                    filtre["filter[meta_compare]"] = "!=";
                    filtre["filter[orderby]"] = "meta_value_num";
                    filtre["filter[order]"] = "ASC";
                } else {
                    filtre["filter[meta_key]"] = "petite_annonce_mensualite_typique";
                    filtre["filter[orderby]"] = "meta_value_num";
                    filtre["filter[order]"] = "ASC";
                }
                break;
            case 'mensualiteDecroissante':
                if (criteresRD.mensualiteMax === "") {
                    filtre["filter[meta_key]"] = "petite_annonce_mensualite_typique";
                    filtre["filter[meta_value]"] = "-1";
                    filtre["filter[meta_compare]"] = "!=";
                    filtre["filter[orderby]"] = "meta_value_num";
                    filtre["filter[order]"] = "DESC";
                } else {
                    filtre["filter[meta_key]"] = "petite_annonce_mensualite_typique";
                    filtre["filter[orderby]"] = "meta_value_num";
                    filtre["filter[order]"] = "DESC";
                }
                break;
            case 'kmCroissant':
                filtre["filter[meta_key]"] = "petite_annonce_kilometrage";
                filtre["filter[orderby]"] = "meta_value_num";
                filtre["filter[order]"] = "ASC";
                break;
            case 'kmDecroissant':
                filtre["filter[meta_key]"] = "petite_annonce_kilometrage";
                filtre["filter[orderby]"] = "meta_value_num";
                filtre["filter[order]"] = "DESC";
                break;
            case 'anneeCroissante':
                filtre["filter[meta_key]"] = "petite_annonce_annee_modele";
                filtre["filter[orderby]"] = "meta_value_num";
                filtre["filter[order]"] = "ASC";
                break;
            case 'anneeDecroissante':
                filtre["filter[meta_key]"] = "petite_annonce_annee_modele";
                filtre["filter[orderby]"] = "meta_value_num";
                filtre["filter[order]"] = "DESC";
                break;
        }
    }
    /////////FIN TRIS CROISSANT/DECROISSANT ////////////
    appelAjax();
    handleInfiniteScroll();
}

//APPEL AJAX POUR FILTRER LES PRODUCTS(Petites annonces) VIA WP-API
currentPage = 2;
let isLoading = false;
let appelAjax = function ($append) {
    try {
        searchRequest.abort();
    } catch (e) {
    }

    search_start();

    let searchRequest = jQuery.ajax({
        url: recherche.api_url,
        method: "GET",
        beforeSend: function () {
            jQuery("#loading").show();
            jQuery("#boutonLoadmorePA").text("Chargement ...");
        },
        complete: function () {
            jQuery("#loading").hide();
        },
        dataType: "json",
        xhrFields: {
            withCredentials: true,
        },
        data: filtre,
        success: (data, textStatus, jqXHR) => {
            let totalPages = jqXHR.getResponseHeader("x-wp-totalpages");
            let countResults = jqXHR.getResponseHeader("x-wp-total");

            //On enlève des résultats les produits qui ne sont pas des véhicules
            let n = data.length;
            data = data.filter(
                (product) =>
                    [
                        "frais-de-traitement-carte-grise",
                        "devis",
                        "carte-grise",
                        "livraison",
                    ].indexOf(product.slug) !== 0
            );

            // Désactivation du bouton Load More si plus de posts à afficher
            if (currentPage >= totalPages) {
                jQuery("#boutonLoadmorePA")
                    .attr("disabled", "disabled")
                    .removeClass("d-inline-block")
                    .addClass("d-none");
            } else {
                jQuery("#boutonLoadmorePA")
                    .addClass("d-inline-block")
                    .removeAttr("disabled")
                    .removeClass("disabled")
                    .text("Afficher plus de véhicules");
            }
            search_end();
            currentPage++;
            render_results_search_vehicules(data, countResults, $append);
            picto_mentions();
            modal_favoris();
        },
        error: (data) => {
            search_end();
            render_error_search_vehicules(recherche.api_url, data);
        },
    });
};

///////////////////////////////////////////////////
////////// FIN FILTRES DE RECHERCHE ///////////////
///////////////////////////////////////////////////

////////////////////////////////////////////////
//////////////   LOADMORE  /////////////////////
////////////////////////////////////////////////
jQuery("#boutonLoadmorePA").click(function () {
    loadMore();
});

function loadMore () {
    if (!isLoading) {
        filtre["filter[posts_per_page]"] = 11;
        filtre["filter[paged]"] = currentPage;
    
        // meta_id++;
        if (meta_id > 1) {
            filtre["filter[meta_query][relation]"] = "AND";
        }
    
        appelAjax("$append");
    }
}

function handleInfiniteScroll () {
    let options = {
        threshold: 0.5
    };

    let observer = new IntersectionObserver(
        function (entries, observer) {
            handleIntersect(entries, observer); 
        }, 
        options
    );

    const $loadMoreBtn = document.querySelector('#boutonLoadmorePA');
    if ($loadMoreBtn) {
        observer.observe($loadMoreBtn);
    }
    
    const handleIntersect = function (entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
    };
}
////////////////////////////////////////////////
/////////////// FIN LOADMORE ///////////////////
////////////////////////////////////////////////

///////////////////////////////////////////////////
//FILTRE DYNAMIQUE SELECT MARQUE SUR SELECT MODELE
///////////////////////////////////////////////////
function afficherModeleParMarque(selectMarque) {
    if (selectMarque) {
        let marque = selectMarque.value;
        let modeleAffiche = document.getElementsByClassName(marque);
        if (modeleAffiche) {
            let modeleAffiche_len = modeleAffiche.length;
            for (let i = 0; i < modeleAffiche_len; i++) {
                modeleAffiche[i].classList.remove("d-none");
            }
        }
    }
}

function cacherModeleParMarque() {
    let modeleCache = document.getElementsByClassName("modele");
    if (modeleCache) {
        let modeleCache_len = modeleCache.length;
        for (let i = 0; i < modeleCache_len; i++) {
            modeleCache[i].classList.add("d-none");
        }
    }
}

///////////////////////////////////////////////////
///////////FIN FILTRE MARQUE SUR MODELE////////////
///////////////////////////////////////////////////

//////////////////////////////////////////////
/////////////////LOCAL STORAGE////////////////
//////////////////////////////////////////////

function getSelectCategorie() {
    return document.getElementById("selectCategorie")
            ? document.getElementById("selectCategorie").value
            : "";
}

function setSelectCategorie(value) {
    if (jQuery("#selectCategorie")) {
        jQuery("#selectCategorie").val(value);
    }
}

function getSelectMarque() {
    return document.getElementById("selectMarque")
            ? document.getElementById("selectMarque").value
            : "";
}

function setSelectMarque(value) {
    if (jQuery("#selectMarque")) {
        jQuery("#selectMarque").val(value === '' ? 'default' : value);
    }
}

function getSelectModele() {
    return document.getElementById("selectModele")
            ? document.getElementById("selectModele").value
            : "";
}

function setSelectModele(value) {
    if (jQuery("#selectModele")) {
        jQuery("#selectModele").val(value);
    }
}

function getSelectPrixMax() {
    return document.getElementById("selectPrixMax")
            ? document.getElementById("selectPrixMax").value
            : "";
}

function setSelectPrixMax(value) {
    if (jQuery("#selectPrixMax")) {
        jQuery("#selectPrixMax").val(value);
    }
}

const bigPriceValue = 10000000;
function getSelectPrix() {
    if (sliderPrix) {
        const initialOptions = Object.keys(sliderPrix.options)
            .filter(key => key === 'min' || key === 'max')
            .reduce((obj, key) => {
                obj[key] = sliderPrix.options[key];
                return obj;
            }, {});

        if (Object.values(initialOptions).join() === sliderPrix.getValue().map((v) => v).join()) {
            return [];
        }
        if (Object.values(initialOptions)[1] === sliderPrix.getValue()[1]) {
            return [sliderPrix.getValue()[0], bigPriceValue]; // when 60 000 €, set simili infinite value 
        }
    }
    return sliderPrix ? sliderPrix.getValue() : [];
}

function setSelectPrix(value) {
    if (value && value.length && sliderPrix) {
        const initialOptions = Object.keys(sliderPrix.options)
            .filter(key => key === 'min' || key === 'max')
            .reduce((obj, key) => {
                obj[key] = sliderPrix.options[key];
                return obj;
            }, {});

        if (value[1] > Object.values(initialOptions)[1]) {
            value[1] = Object.values(initialOptions)[1];
        }

        sliderPrix.setValue(value, true, true);
    }
}

function getSelectMensualite() {
    if (sliderMensualites) {
        const initialOptions = Object.keys(sliderMensualites.options)
            .filter(key => key === 'min' || key === 'max')
            .reduce((obj, key) => {
                obj[key] = sliderMensualites.options[key];
                return obj;
            }, {});
        if (Object.values(initialOptions).join() === sliderMensualites.getValue().map((v) => v).join()) {
            return [];
        }
    }
    return sliderMensualites ? sliderMensualites.getValue() : [];
}

function setSelectMensualite(value) {
    if (value && value.length && sliderMensualites) {
        sliderMensualites.setValue(value, true, true);
    }
}

function getSelectMensualiteMax() {
    return document.getElementById("selectMensualiteMax")
            ? document.getElementById("selectMensualiteMax").value
            : "";
}

function setSelectMensualiteMax(value) {
    if (jQuery("#selectMensualiteMax")) {
        jQuery("#selectMensualiteMax").val(value);
    }
}

function getSelectKmMax() {
    return document.getElementById("selectKmMax")
            ? document.getElementById("selectKmMax").value
            : "";
}

function setSelectKmMax(value) {
    if (jQuery("#selectKmMax")) {
        jQuery("#selectKmMax").val(value);
    }
}

function getSelectEnergie() {
    return document.getElementById("selectEnergie")
            ? document.getElementById("selectEnergie").value
            : "";
}

function setSelectEnergie(value) {
    if (jQuery("#selectEnergie") && value != 'diesel-hybride,essence-hybride') {
        jQuery("#selectEnergie").val(value);
    }
}

function getSelectTypeBoite() {
    return document.getElementById("selectTypeBoite")
            ? document.getElementById("selectTypeBoite").value
            : "";
}

function setSelectTypeBoite(value) {
    if (jQuery("#selectTypeBoite")) {
        jQuery("#selectTypeBoite").val(value);
    }
}

function getSelectAnneeMin() {
    return document.getElementById("selectAnneeMin")
            ? document.getElementById("selectAnneeMin").value
            : "";
}

function setSelectAnneeMin(value) {
    if (jQuery("#selectAnneeMin")) {
        jQuery("#selectAnneeMin").val(value);
    }
}

function getSelectOccasionNeuf() {
    return document.getElementById("selectOccasionNeuf")
            ? document.getElementById("selectOccasionNeuf").value
            : "";
}

function setSelectOccasionNeuf(value) {
    if (jQuery("#selectOccasionNeuf")) {
        jQuery("#selectOccasionNeuf").val(value);
    }
}

function getSelectTypeClientele() {
    return document.getElementById("selectTypeClientele")
            ? document.getElementById("selectTypeClientele").value
            : "";
}

function setSelectTypeClientele(value) {
    if (jQuery("#selectTypeClientele")) {
        jQuery("#selectTypeClientele").val(value);
    }
}

function getSelectConcession() {
    return document.getElementById("selectConcession")
            ? document.getElementById("selectConcession").value
            : "";
}

function setSelectConcession(value) {
    if (jQuery("#selectConcession")) {
        jQuery("#selectConcession").val(value);
    }
}

function getUtilitaireParticulier() {
    let res = [];
    if(document.getElementById("checkbox-utilitaire") && document.getElementById("checkbox-utilitaire").checked){
        res.push('utilitaire')
    }
    if(document.getElementById("checkbox-tourisme") && document.getElementById("checkbox-tourisme").checked){
        res.push('particulier')
    }
    return res
}

function setUtilitaireParticulier(value) {
    if (value === '') {
        if(document.getElementById("checkbox-utilitaire")) {
            document.getElementById("checkbox-utilitaire").checked = true;
        }
        if(document.getElementById("checkbox-tourisme")){
            document.getElementById("checkbox-tourisme").checked = true;
        }
    } else {
        if(document.getElementById("checkbox-utilitaire") && value == 'utilitaire'){
            document.getElementById("checkbox-utilitaire").checked = true
            document.getElementById("checkbox-tourisme").checked = false
        }
        if(document.getElementById("checkbox-tourisme") && value == 'particulier'){
            document.getElementById("checkbox-utilitaire").checked = false
            document.getElementById("checkbox-tourisme").checked = true
        }
    }
}

function getSelectAccrochePredefinie() {
    return document.getElementById("selectAccrochePredefinie")
            ? document.getElementById("selectAccrochePredefinie").value
            : "";
}

function setSelectAccrochePredefinie(value) {
    if (jQuery("#selectAccrochePredefinie")) {
        jQuery("#selectAccrochePredefinie").val(value);
    }
}

function getSearchQuery() {
    return jQuery("[name='search']").val();
}

function setSearchQuery(value) {
    if (jQuery("[name='search']")) {
        jQuery("[name='search']").val(value);
    }
}

//POUR PRE REMPLIR LES CHAMPS DU FORMULAIRE DE RECHERCHE DE BASE
function setSelectFromLocalStoragePourRechercheSimple() {
    if (window.localStorage.getItem("criteresRecherche")) {
        let criteres = JSON.parse(window.localStorage.getItem("criteresRecherche"));
        setSelectCategorie(criteres.categorie);
        setSelectMarque(criteres.marque);
        setSelectModele(criteres.modele);
        setSelectPrixMax(criteres.prixMax);
        setSelectPrix(criteres.prix);
        setSelectMensualite(criteres.mensualite);
        setUtilitaireParticulier(criteres.utilitaire_particulier);
        setSearchQuery(criteres.searchQuery);
    } else {
        clearLocalStoragePourRechercheSimple();
    }
}

//POUR PRE REMPLIR LES CHAMPS DU FORMULAIRE DE RECHERCHE DETAILLEE
function setSelectFromLocalStoragePourRechercheDetaillee() {
    if (window.localStorage.getItem("criteresRechercheDetaillee")) {
        let criteresRechercheDetaillee = JSON.parse(window.localStorage.getItem("criteresRechercheDetaillee"));
        setSelectMensualiteMax(criteresRechercheDetaillee.mensualiteMax);
        setSelectKmMax(criteresRechercheDetaillee.kmMax);
        setSelectEnergie(criteresRechercheDetaillee.type_energie);
        setSelectTypeBoite(criteresRechercheDetaillee.type_boite);
        setSelectAnneeMin(criteresRechercheDetaillee.anneeMin);
        setSelectOccasionNeuf(criteresRechercheDetaillee.occasion_neuf);
        setSelectTypeClientele(criteresRechercheDetaillee.type_clientele);
        setSelectConcession(criteresRechercheDetaillee.concession);
        setSelectAccrochePredefinie(criteresRechercheDetaillee.accrochePredefinie);
        // setPretAPartir(criteresRechercheDetaillee.pret_a_partir);
        // setReference(criteresRechercheDetaillee.reference);
    } else {
        clearLocalStoragePourRechercheDetaillee();
    }
}

function setLocalStorageFromSelectPourRechercheSimple() {
    let criteresRecherche = {
        categorie: getSelectCategorie(),
        marque: getSelectMarque(),
        modele: getSelectModele(),
        prixMax: getSelectPrixMax(),
        prix: getSelectPrix(),
        mensualite: getSelectMensualite(),
        utilitaire_particulier: getUtilitaireParticulier()
    };
    localStorage.setItem("criteresRecherche", JSON.stringify(criteresRecherche));
}

function setLocalStorageFromSelectPourRechercheDetaillee() {
    let criteresRechercheDetaillee = {
        mensualiteMax: getSelectMensualiteMax(),
        kmMax: getSelectKmMax(),
        type_energie: getSelectEnergie(),
        type_boite: getSelectTypeBoite(),
        anneeMin: getSelectAnneeMin(),
        occasion_neuf: getSelectOccasionNeuf(),
        type_clientele: getSelectTypeClientele(),
        concession: getSelectConcession(),
        accrochePredefinie: getSelectAccrochePredefinie(),
        // pret_a_partir: getPretAPartir(),
        // reference: getReference()
    };
    localStorage.setItem("criteresRechercheDetaillee", JSON.stringify(criteresRechercheDetaillee));
}

function clearLocalStoragePourRechercheSimple() {
    let criteresRecherche = {
        categorie: "",
        marque: "",
        modele: "",
        prixMax: "",
        prix: [],
        mensualite: [],
        utilitaire_particulier: "",
        searchQuery: ""
    };
    localStorage.setItem("criteresRecherche", JSON.stringify(criteresRecherche));
}

function clearLocalStoragePourRechercheDetaillee() {
    let criteresRechercheDetaillee = {
        mensualiteMax: "",
        kmMax: "",
        type_energie: "",
        type_boite: "",
        anneeMin: "",
        occasion_neuf: "",
        type_clientele: "",
        concession: "",
        accrochePredefinie: ""
    };
    localStorage.setItem("criteresRechercheDetaillee", JSON.stringify(criteresRechercheDetaillee));
}

function clearLocalStoragePourRecherche() {
    clearLocalStoragePourRechercheSimple();
    clearLocalStoragePourRechercheDetaillee();
}

const hasInitialSelectedValueHidden = function () {
    let toReturn = false;
    if (window.localStorage.getItem('criteresRecherche')) {
        const criteresRecherche = JSON.parse(window.localStorage.getItem('criteresRecherche'));
        toReturn = (
            criteresRecherche.categorie !== ''
        );
    }
    if (!toReturn && window.localStorage.getItem("criteresRechercheDetaillee")) {
        let criteresRechercheDetaillee = JSON.parse(
            window.localStorage.getItem("criteresRechercheDetaillee")
        );
        toReturn = (
            criteresRechercheDetaillee.mensualiteMax != "" ||
            criteresRechercheDetaillee.kmMax != "" ||
            criteresRechercheDetaillee.type_energie != "" ||
            criteresRechercheDetaillee.type_boite != "" ||
            criteresRechercheDetaillee.anneeMin != "" ||
            criteresRechercheDetaillee.occasion_neuf != "" ||
            criteresRechercheDetaillee.type_clientele != "" ||
            criteresRechercheDetaillee.concession != "" ||
            criteresRechercheDetaillee.accrochePredefinie != ""
        );
    }
    return toReturn;
};


function rechercheParUrl(marque, modele, categorie, prix, mensualite, annee, kilometrage, typeVente, typeEnergie, typeBoite, concession, utilitaire_particulier, accroche_predefinie, search_query /*,reference*/) {
    clearLocalStoragePourRecherche();
    let criteres = JSON.parse(window.localStorage.getItem("criteresRecherche"));
    let criteresDetailles = JSON.parse(window.localStorage.getItem("criteresRechercheDetaillee"));

    if (marque) {
        criteres.marque = marque.textContent.toString();
        if (modele) {
            criteres.modele = modele.textContent.toString();
        }
    }
    if (categorie) {
        criteres.categorie = categorie.textContent.toString();
    }
    if (prix) {
        criteres.prixMax = prix.textContent.toString();
    }
    if (mensualite) {
        criteresDetailles.mensualiteMax = mensualite.textContent.toString();
    }
    if (annee) {
        criteresDetailles.anneeMin = annee.textContent.toString();
    }
    if (kilometrage) {
        criteresDetailles.kmMax = kilometrage.textContent.toString();
    }
    if (typeVente) {
        criteresDetailles.occasion_neuf = typeVente.textContent.toString();
    }
    if (typeEnergie) {
        criteresDetailles.type_energie = typeEnergie.textContent.toString();
    }
    if (typeBoite) {
        criteresDetailles.type_boite = typeBoite.textContent.toString();
    }
    if (concession) {
        criteresDetailles.concession = concession.textContent.toString();
    }
    if (utilitaire_particulier) {
        criteres.utilitaire_particulier = utilitaire_particulier.textContent.toString();
    }

    if (accroche_predefinie) {
        criteresDetailles.accrochePredefinie = accroche_predefinie.textContent.toString();
    }

    if (search_query) {
        criteres.searchQuery = search_query.textContent.toString();
    }

    localStorage.setItem("criteresRecherche", JSON.stringify(criteres));
    localStorage.setItem("criteresRechercheDetaillee", JSON.stringify(criteresDetailles));
    
    if (hasInitialSelectedValueHidden()) {
        jQuery(".more-criteres").addClass('d-block');
        jQuery(".plus-de-criteres").text('- Moins d\'options');
    }
}


//////////////////////////////////////////////
////////////////FIN LOCAL STORAGE/////////////
//////////////////////////////////////////////

// Permet de formater les nombres pour les milliers en ajax
function formatNombre(nbr) {
    try {
        return parseInt(nbr, 10).toLocaleString("fr-FR");
    } catch (e) {
        let nombre = "" + nbr;
        let retour = "";
        let count = 0;
        for (let i = nombre.length - 1; i >= 0; i--) {
            if (count != 0 && count % 3 == 0) retour = nombre[i] + " " + retour;
            else retour = nombre[i] + retour;
            count++;
        }
        return retour;
    }
}

function getFormattedAccroche (post) {
  let badgeHtml = '';
  // Fix: Temporary remove all ope_carburant accroches
  if (!!post.petite_annonce_accroches_predefinies &&
        (post.petite_annonce_accroches_predefinies.value === 'ope_carburant' || post.petite_annonce_accroches_predefinies.value === '--' || post.petite_annonce_accroches_predefinies.value === '0')
    ) {
    return badgeHtml;
  }
  if (!!post.petite_annonce_accroche_saisie_libre || !!post.petite_annonce_accroches_predefinies) {
    if (!!post.petite_annonce_accroches_url) {
      badgeHtml += '<a href="'+post.petite_annonce_accroches_url+'" class="badge-accroche badge-accroche--link badge-accroche--color-'+post.petite_annonce_accroches_color+'">';
    } else {
        badgeHtml += '<span class="badge-accroche badge-accroche--color-'+post.petite_annonce_accroches_color+'">';
    }
    badgeHtml += !!post.petite_annonce_accroche_saisie_libre ? post.petite_annonce_accroche_saisie_libre : !!post.petite_annonce_accroches_predefinies ? post.petite_annonce_accroches_predefinies.label : '';
    badgeHtml += !!post.petite_annonce_accroches_url ? '</a>' : '</span>';
  }
  return badgeHtml;
}

//Pour afficher ou non les accroches
function isDisplayAccroche(accrochePredefinie) {
    if (!!accrochePredefinie) {
        let dt = new Date();
        let month = dt.getMonth() + 1;
        let day = dt.getDate();
        let hours = dt.getHours();
        let minutes = dt.getMinutes();
        let time =
            dt.getFullYear() +
            (month < 10 ? "0" : "") + month +
            (day < 10 ? "0" : "") + day +
            (hours < 10 ? "0" : "") + hours +
            (minutes < 10 ? "0" : "") + minutes;
        let postAccrocheFormat = accrochePredefinie
            .split("/")
            .join(",")
            .split(" ")
            .join(",")
            .split(":")
            .join(",")
            .split(",");
        let postAccroche =
            postAccrocheFormat[2] +
            postAccrocheFormat[1] +
            postAccrocheFormat[0] +
            postAccrocheFormat[3] +
            postAccrocheFormat[4];
        if (time <= postAccroche) {
            return true;
        } else {
            return false
        }
    } else {
        return true;
    }
}

//API MENTIONS LEGALES
function picto_mentions() {
  jQuery('#myModal').on('shown.bs.modal', function (event) {
    const $initiator = jQuery(event.relatedTarget);
    const $modal = jQuery(this);
    const $modalLoading = $modal.find('.loading');
    const product_id = $initiator.prop("id");
    jQuery.ajax({
      url: recherche.url_mentions + product_id,
      method: "GET",
      dataType: "json",
      xhrFields: {
        withCredentials: true,
      },
      beforeSend: function () {
        $modalLoading.show();
      },
      complete: function () {
        $modalLoading.hide();
      },
      success: (data) => {
        if (data["code-erreur"] === "OK") {
          $modal.find(".modal-body").html(data["html"]);
        } else {
          console.log(data["message-erreur"]);
        }
      },
      error: (data) => {
        console.log(data["message-erreur"]);
        console.log(
            "Erreur Ajax lors de la récupération des mentions légales."
        );
      }
    });
  });

  jQuery('#myModal').on('hidden.bs.modal\t', function (event) {
    const $modal = jQuery(this);
    $modal.find(".modal-body").html('');
  });
}

//FORM PRE RESERVATION
document.addEventListener("DOMContentLoaded", function () {
    let livraison_etablissement = document.getElementById("livraison_etablissement");
    let livraison_domicile = document.getElementById("livraison_domicile");
    let financement_reprise = document.getElementById("financement_reprise");
    let financement_financement = document.getElementById("financement_financement");
    let financement_comptant = document.getElementById("financement_comptant");
    let selectCG = document.getElementById("selectCarteGrise");
    let prixCG = document.getElementById("prixCG");
    let puissanceFiscale = document.getElementById("puissanceFiscale")

    if (livraison_domicile) {
        livraison_domicile.onclick = function () {
            jQuery("#submit_livraison").attr("disabled", "true");
            jQuery("#bloc_livraison_etablissement").hide();
            jQuery("#livraison-rue").attr("required", "true");
            jQuery("#livraison-codepostal").attr("required", "true");
            jQuery("#livraison-ville").attr("required", "true");
            jQuery("#bloc_livraison_domicile").show();
            jQuery("#bloc_livraison_domicile").removeAttr("required");
        };
    }
    if (livraison_etablissement) {
        livraison_etablissement.onclick = function () {
            jQuery("#bloc_livraison_domicile").attr("required", "true");
            jQuery("#bloc_livraison_domicile").hide();
            jQuery("#bloc_livraison_etablissement").show();
            jQuery("#livraison-rue").removeAttr("required");
            jQuery("#livraison-codepostal").removeAttr("required");
            jQuery("#livraison-ville").removeAttr("required");
            jQuery("#submit_livraison").removeAttr("disabled");
        };
    }
    if (financement_reprise) {
        financement_reprise.onclick = function () {
            jQuery("#bloc_financement_reprise").toggleClass("d-block");
            if (jQuery("#bloc_financement_reprise").hasClass("d-block")) {
                jQuery("#reprise_marque").attr("required", "true");
                jQuery("#reprise_modele").attr("required", "true");
                jQuery("#reprise_version").attr("required", "true");
                jQuery("#reprise_annee").attr("required", "true");
                jQuery("#reprise_km").attr("required", "true");
            }
        };
    }

    if (financement_financement) {
        financement_financement.onclick = function () {
            jQuery("#submit_financement").removeAttr("disabled");
        };
    }
    if (financement_comptant) {
        financement_comptant.onclick = function () {
            jQuery("#submit_financement").removeAttr("disabled");
        };
    }

    if (selectCG) {
        prixCG.innerHTML = (Math.round((parseFloat(selectCG.value) * parseFloat(puissanceFiscale.value)) * 100) / 100).toFixed(2);
        selectCG.onchange = function () {
            prixCG.innerHTML = (Math.round((parseFloat(selectCG.value) * parseFloat(puissanceFiscale.value)) * 100) / 100).toFixed(2);
        }
    }


});

document.addEventListener("DOMContentLoaded", function () {
    /////////////// ALERTE ///////////////////
    const $searchModalAlert = jQuery('#search-modal-alert');
    const $searchModalAlertForm = jQuery('#search-modal-alert-form');
    
    if ($searchModalAlert && $searchModalAlertForm) {
        const $searchModalAlertFormTitle = jQuery('#search-alert-title');
        const $searchModalAlertCallConsent = jQuery('#search-alert-call-consent');
        const $searchModalAlertRGPDConsent = jQuery('#search-alert-rgpd-consent');
        const $searchModalAlertLastname = jQuery('#search-alert-lastname');
        const $searchModalAlertFirstname = jQuery('#search-alert-firstname');
        const $searchModalAlertPhone = jQuery('#search-alert-phone');
        const $searchModalAlertAdditionalFields = jQuery('#search-alert-additional-fields');
        const $searchModalAlertFormSuccess = jQuery('#search-modal-alert-success');
        const $searchModalAlertFormError = jQuery('#search-modal-alert-error');
        const $searchModalAlertFormWarningNoCriteria = jQuery('#search-modal-alert-warning-no-criteria');
        const $searchModalAlertLoading = jQuery('#search-modal-loading');
        
        // On show alert Modal
        $searchModalAlert.on('shown.bs.modal', function () {
            // Remove criteria informations
            const $searchFormCriteriaInformation = jQuery('#search-modal-alert-crieria');
            $searchFormCriteriaInformation.html('');
    
            // Reset
            let searchAlertTitle = 'Ma recherche';
            $searchModalAlertFormTitle.value = '';
            $searchModalAlertCallConsent.prop('checked', false);
            $searchModalAlertRGPDConsent.prop('checked', false);
            $searchModalAlertRGPDConsent.prop('required', false);
            $searchModalAlertLastname.prop('required', false);
            $searchModalAlertFirstname.prop('required', false);
            $searchModalAlertPhone.prop('required', false);
            $searchModalAlertAdditionalFields.addClass('d-none');
            $searchModalAlertForm.removeClass('d-none');
            $searchModalAlertFormSuccess.addClass('d-none');
            $searchModalAlertFormError.addClass('d-none');
            $searchModalAlertFormError.text("Une erreur s'est produite lors de l'enregistrement de votre alerte.");
            $searchModalAlertFormWarningNoCriteria.addClass('d-none');
    
            const $searchForm = jQuery("#formRecherche");
            const serializeDataArray = $searchForm.serializeArray();
            let searchCriteriaHtml = `<p>Les critères de recherches ci-dessous seront enregistrés:</p>
            <div class="bg-lightgrey p-4 mb-4">
            <ul class="mb-0 list-unstyled">
            `;
            let searchCriteriaCount = 0;
            serializeDataArray.forEach((data) => {
                if (data.value !== '' && data.value !== 'default' && data.name !== 'redirect_on_submit') {
                    const criteriaTitle = $searchForm.find('[name="'+data.name+'"] option').first().text();
                    const criteriaValue = $searchForm.find('[name="'+data.name+'"] option[value="'+data.value+'"]').text();
                    searchCriteriaHtml += '<li>'+criteriaTitle+': <b>'+criteriaValue+'</b></li>';
                    
                    if (data.name === 'selectMarque' || data.name === 'selectModele') {
                        searchAlertTitle += ' ' + criteriaValue;
                    }
    
                    searchCriteriaCount++;
                }
            });
            if (getSelectPrix().length) {
                searchCriteriaHtml += '<li>Prix: <b>Entre '+getSelectPrix()[0]+' et '+getSelectPrix()[1]+'€</b></li>';
                searchCriteriaCount++;
            }
            if (getSelectMensualite().length) {
                searchCriteriaHtml += '<li>Mensualités: <b>Entre '+getSelectMensualite()[0]+' et '+getSelectMensualite()[1]+'€</b></li>';
                searchCriteriaCount++;
            }
            if (getSearchQuery().length) {
                searchCriteriaHtml += '<li>Recherche: <b>'+getSearchQuery()+'</b></li>';
                searchAlertTitle += ' ' + getSearchQuery();
                searchCriteriaCount++;
            }
            const isCheckedUtilitaire = document.getElementById('checkbox-utilitaire').checked;
            const isCheckedTourisme = document.getElementById('checkbox-tourisme').checked;
            if (!isCheckedTourisme || !isCheckedUtilitaire) {
                searchCriteriaHtml += '<li>Utilitaire/Particulier: <b>'+ (isCheckedTourisme ? 'Particulier' : 'Utilitaire') +'</b></li>';
                searchCriteriaCount++;
            }
            searchCriteriaHtml += '</ul></div>';
            if (searchCriteriaCount === 0) {
                searchCriteriaHtml = '';
                $searchModalAlertFormWarningNoCriteria.removeClass('d-none');
                $searchModalAlertForm.addClass('d-none');
            }
            $searchFormCriteriaInformation.html(searchCriteriaHtml);
            $searchModalAlertFormTitle.val(searchAlertTitle);
        });
        
        // On submit alert modal form
        $searchModalAlertForm.on('submit', (e) => {
            e.preventDefault();
            if ($searchModalAlertCallConsent.is(':checked') && !$searchModalAlertRGPDConsent.is(':checked')) {
                console.warn('[Alerte] Les conditions d\'utilisation doivent être acceptées.'); // Should never pass here due to required field..
            } else {
                const $searchModalAlertForm = jQuery(e.target);
                
                $searchModalAlertLoading.removeClass('d-none');
    
                let data = [
                    ...jQuery('#formRecherche').serializeArray(),
                    {
                        name:'email',
                        value: $searchModalAlertForm.find('#search-alert-email').val()
                    },
                    {
                        name:'lastname',
                        value: $searchModalAlertForm.find('#search-alert-lastname').val()
                    },
                    {
                        name:'firstname',
                        value: $searchModalAlertForm.find('#search-alert-firstname').val()
                    },
                    {
                        name:'phone',
                        value: $searchModalAlertForm.find('#search-alert-phone').val()
                    },
                    {
                        name: 'title',
                        value: $searchModalAlertForm.find('#search-alert-title').val()
                    },
                    {
                        name: 'call_consent',
                        value: $searchModalAlertCallConsent.is(':checked')
                    },
                    {
                        name: 'rgpd_consent',
                        value: $searchModalAlertRGPDConsent.is(':checked')
                    }
                ];
    
                if (getSelectPrix().length) {
                    data = [
                        ...data,
                        {
                            name: 'price_min',
                            value: getSelectPrix()[0]
                        },
                        {
                            name: 'price_max',
                            value: getSelectPrix()[1]
                        }
                    ];
                }
    
                if (getSelectMensualite().length) {
                    data = [
                        ...data,
                        {
                            name: 'monthly_min',
                            value: getSelectMensualite()[0]
                        },
                        {
                            name: 'monthly_max',
                            value: getSelectMensualite()[1]
                        }
                    ];
                }

                if (getSearchQuery().length) {
                    data = [
                        ...data,
                        {
                            name: 'search_query',
                            value: getSearchQuery()
                        }
                    ];
                }
    
                const isCheckedUtilitaire = document.getElementById('checkbox-utilitaire').checked;
                const isCheckedTourisme = document.getElementById('checkbox-tourisme').checked;
    
                if (!isCheckedTourisme || !isCheckedUtilitaire) {
                    data = [
                        ...data,
                        {
                            name: 'perso_pro',
                            value: isCheckedUtilitaire && isCheckedTourisme ? 'both' : (isCheckedTourisme ? 'personal' : 'pro')
                        }
                    ];
                }
        
                jQuery.ajax({
                    type: 'post',
                    url: window.location.origin + '/enregistrement-alerte',
                    data: data,
                    complete: () => {
                        $searchModalAlertLoading.addClass('d-none');
                    },
                    success: (jsonData) => {
                        if (jsonData) {
                            const data = JSON.parse(jsonData);
                            if (data.success) {
                                $searchModalAlertFormSuccess.removeClass('d-none');
                                $searchModalAlertFormError.addClass('d-none');
                                $searchModalAlertForm.addClass('d-none');
                                setTimeout(() => {
                                    $searchModalAlert.modal('hide');
                                }, 2500);

                                if (data.warning) {
                                    console.warn('[Alerte]', data.warning);
                                }
                            } else {
                                $searchModalAlertFormError.text(data.error);
                                $searchModalAlertFormError.removeClass('d-none');
                                console.warn('[Alerte] Erreur retour JSON lors de la création de l\'alerte.', data.error);
                            }
                        }
                    },
                    error: (error) => {
                        $searchModalAlertFormError.removeClass('d-none');
                        console.warn('[Alerte] Erreur lors de la création de l\'alerte.', error);
                    }
                });
            }
        });

        $searchModalAlertCallConsent.on('change', (e) => {
            if ($searchModalAlertCallConsent.is(':checked')) {
                $searchModalAlertAdditionalFields.removeClass('d-none');
                $searchModalAlertRGPDConsent.prop('required', true);
                $searchModalAlertLastname.prop('required', true);
                $searchModalAlertFirstname.prop('required', true);
                $searchModalAlertPhone.prop('required', true);
            } else {
                $searchModalAlertAdditionalFields.addClass('d-none');
                $searchModalAlertRGPDConsent.prop('required', false);
                $searchModalAlertLastname.prop('required', false);
                $searchModalAlertFirstname.prop('required', false);
                $searchModalAlertPhone.prop('required', false);
            }
        });
    }

    /////////////// COLLAPSE FILTRES ///////////////////
    // jQuery("#collapse-filtres").on("click", (e) => {
    //     jQuery(".filtres__dropdown").slideToggle();
    //     jQuery("#collapse-filtres").find("svg").removeClass("rotate");
    // });
    // jQuery("body").on("click", function (e) {
    //     jQuery("#collapse-filtres").find(".filtres__dropdown").slideToggle();
    //     jQuery("#collapse-filtres").find("svg").removeClass("rotate");
    // });

    /////////////// AFFICHER PLUS DE CRITERES ///////////////////
    jQuery(".plus-de-criteres").on("click", (e) => {
        e.preventDefault();
        let more_criteres = jQuery(".more-criteres");
        more_criteres.toggleClass('d-block');
        if (more_criteres.hasClass('d-block')) {
            jQuery(".plus-de-criteres").text('- Moins d\'options');
        } else {
            jQuery(".plus-de-criteres").text('+ Plus d\'options');
        }
        ;
    });

    /////WPFORMS RDV ESSAI
    let image_selectionnee = jQuery("#wpforms-1374-field_16");
    let image_selectionnee_defaut = jQuery(
        "#wpforms-1374-field_16 .wpforms-selected"
    );
    if (image_selectionnee_defaut.find("input")[0] !== undefined) {
        afficherModeleParMarqueFormRDVEssai(
            image_selectionnee_defaut.find("input")[0].value
        );
        image_selectionnee.on("click", "li", function () {
            let marque = jQuery(this).find("input")[0].value;
            afficherModeleParMarqueFormRDVEssai(marque);
        });
    }
});

/////WPFORMS RDV ESSAI
function afficherModeleParMarqueFormRDVEssai(marque) {
    let filtreRdv = {};
    meta_id = 0;

    filtreRdv["filter[meta_query][" + meta_id + "][key]"] = "vehicule_cpt_marque_presentation";
    filtreRdv["filter[meta_query][" + meta_id + "][value]"] = marque;
    filtreRdv["filter[meta_query][" + meta_id + "][compare]"] = "LIKE";
    filtreRdv["filter[posts_per_page]"] = 99;
    filtreRdv["filter[nopaging]"] = true;
    filtreRdv["filter[order]"] = "ASC";
    filtreRdv["filter[post_status]"] = "publish";
    meta_id++;

    jQuery.ajax({
        url: modeles.url,
        method: "GET",
        dataType: "json",
        xhrFields: {
            withCredentials: true,
        },
        data: filtreRdv,
        success: (data) => {
            jQuery("#wpforms-1374-field_42 option").removeClass("d-block");
            jQuery("#wpforms-1374-field_42 option").addClass("d-none");
            if (data !== null && Object.keys(data).length > 0) {
                for (let key in data) {
                    let post = data[key];
                    if (key == 0) {
                        document.getElementById('wpforms-1374-field_42').value = post.id;
                    }
                    jQuery('#wpforms-1374-field_42 option[value="' + post.id + '"]').removeClass("d-none");
                    jQuery('#wpforms-1374-field_42 option[value="' + post.id + '"]').addClass("d-block");
                }
            }
        },
        error: (data) => {
            console.log(data["message-erreur"]);
            console.log("Erreur Ajax lors de la récupération des modèles.");
        },
    });
}


/////FAVORIS NON LOGGE
function modal_favoris() {
    let modal_fav = jQuery("#modal_fav");
    let not_logged_favori = jQuery(".not_logged_favori").on("click", function () {
        modal_fav.toggleClass("d-block");
    });
    let closemodalfav = jQuery("#closemodalfav");
    if (closemodalfav) {
        closemodalfav.on("click", function () {
            modal_fav.removeClass("d-block");
            modal_fav.addClass("none");
            jQuery("body").css("overflow", "auto");
        });
    }
    jQuery(document).click(function (event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!jQuery(event.target).closest(".modal_fav,.not_logged_favori").length) {
            jQuery("body").find("#modal_fav").removeClass("d-block").addClass("none");
        }
    });
}

function initPromoSlidesFlickity () {
    const searchBannerSlidesFlickity = jQuery('.card-cell--flickity');

    if (searchBannerSlidesFlickity.length) {
        searchBannerSlidesFlickity.flickity({
            "contain": true,
            "prevNextButtons": true,
            "pageDots": true,
            "wrapAround": true,
            "cellAlign": "left",
            "autoPlay": 2000,
            "pauseAutoPlayOnHover": true,
            "lazyLoad": false,
            "hash": true,
            "groupCells": 1,
            "imagesLoaded": true
        });
    }
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
